import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import ImagePerson from "@/components/functionals/ImagePerson.vue";
import SLAClolorStatus from "@/components/functionals/SLAClolorStatus";
import GetRate from "@/components/requests/internal/GetRate.vue";
import ColorType from "@/components/functionals/ColorType.vue";

export const COLUMNAS = [
  {
    prop: "Id",
    name: "NO",
    width: 80,
    sortable: true,
    formatter: SLAClolorStatus
  },
  {
    prop: "CustomerName",
    name: "Cliente",
    minWidth: 300,
    sortable: true,
    formatter: (row) => {
      if (
        row.CustomerName === "" ||
        row.CustomerName === null ||
        row.CustomerName === undefined
      ) {
        return row.Customer.Name;
      }
      return row.CustomerName;
    }
  },
  {
    name: "Clasificación",
    prop: "Customer.Clasification",
    width: 130,
    sortable: true,
    formatter: (row) => row.Customer.Clasification
  },
  {
    prop: "ServiceRequestType.Description",
    name: "Solictud",
    sortable: true,
    formatter: (row) => {
      return row.ServiceRequestType ? row.ServiceRequestType.Description : "";
    },
    minWidth: 200
  },
  {
    prop: "DeviceQuantity",
    name: "Cantidad",
    align: "center",
    width: 110,
    sortable: true,
    formatter: (row) =>
      row.DeviceQuantity ?? row.DeviceQuantity > 1 ? row.DeviceQuantity : ""
  },
  {
    prop: "Device",
    name: "Equipo",
    width: 80
  },
  {
    prop: "AssignedTechnician.FullName",
    name: "Tecnico",
    minWidth: 250,
    formatter: ImagePerson,
    sortable: true,
    attrs: {
      imgKey: "AssignedTechnicianImage"
    }
  },
  {
    prop: "SLAHoursToRespond",
    name: "SLA",
    minWidth: 75,
    sortable: true,
    formatter: (row) => {
      return row.SLAHoursToRespond ? row.SLAHoursToRespond : "";
    }
  },
  {
    //prop: "DiasRetraso",
    name: "Retraso",
    align: "center",
    minWidth: 100,
    sortable: true,
    formatter: ColorType
    /*
    formatter: row => {
      return <b style="background-color:powderblue;">$`{row.DiasRetraso + " Dias"}`</b>;
    }
    */
  },
  {
    prop: "RequestDate",
    name: "Creado",
    formatter: DatetimeFormatter,
    minWidth: 190,
    sortable: true
  },
  {
    prop: "DueDate",
    name: "Limite",
    formatter: DatetimeFormatter,
    minWidth: 190,
    sortable: true
  },
  {
    prop: "Customer.CustomerService",
    name: "Servicio",
    formatter: ImagePerson,
    minWidth: 250,
    sortable: true,
    attrs: {
      imgKey: "CustomerServiceImage"
    }
  },
  {
    prop: "CreatedByUser.FirstName",
    name: "Creada Por",
    formatter: ImagePerson,
    minWidth: 250,
    sortable: true,
    attrs: {
      imgKey: "CreatedByImage"
    }
  },
  {
    prop: "StatusDescription",
    name: "Estado",
    minWidth: 100
  },
  {
    prop: "NameValidator",
    name: "Validado por",
    formatter: ImagePerson,
    minWidth: 250,
    attrs: {
      imgKey: "imageValidator"
    }
  },
  {
    prop: "Valoracion",
    name: "Calificacion",
    sortable: true,
    formatter: GetRate,
    minWidth: 145
  },
  {
    prop: "ValoracionComents",
    name: "Nota de Calificacion",
    minWidth: 200
  },
  {
    prop: "ServiceRequestCloseDate",
    name: "Fecha Cierre",
    formatter: DatetimeFormatter,
    minWidth: 190,
    sortable: true
  }
];

export const actionView = {
  icon: "el-icon-view",
  label: "Ver",
  command: "view"
};

export const actionCancel = {
  icon: "el-icon-delete",
  label: "Cancelar",
  command: "cancel"
};

export const ACTIONS = {
  0: [
    actionView,
    {
      icon: "el-icon-user",
      label: "Asignar Tecnico",
      command: "assign-technician",
      condition: (row) => {
        switch (row.ServiceRequestTypeId) {
          case 2: //INSTALACION
          case 3: //DESINSTALACION
          case 4: //CAMBIO DE EQUIPO
            return row.ContractCode ? true : false;
          default:
            return true;
        }
      }
    },
    {
      icon: "el-icon-document-checked",
      label: "Validar Contrato",
      command: "validate-contract",
      condition: (row) => {
        switch (row.ServiceRequestTypeId) {
          case 2: //INSTALACION
          case 3: //DESINSTALACION
          case 4: //CAMBIO DE EQUIPO
            return row.ContractCode ? false : true;
          default:
            return false;
        }
      }
    },
    {
      icon: "el-icon-circle-close",
      label: "Cerrar",
      command: "close"
    },
    actionCancel
  ],
  2: [
    actionView,
    actionCancel,
    {
      icon: "el-icon-user",
      label: "Reasignar tecnico",
      command: "reallocate"
    },
    {
      icon: "el-icon-plus",
      label: "Coordinar instalacion",
      command: "coordinate_instalation",
      condition: (row) => {
        return row.RequiresInstallersCoordination;
      }
    },
    {
      icon: "el-icon-plus",
      label: "Registrar dispositivos",
      command: "register_diveces",
      condition: (row) => {
        return (
          !row.RequiresInstallersCoordination && row.RequiresDeviceRegistration
        );
      }
    },
    {
      icon: "el-icon-circle-close",
      label: "Cerrar",
      command: "close"
    }
  ],
  3: [
    actionView,
    {
      icon: "el-icon-user",
      label: "Reasignar tecnico",
      command: "reallocate",
      condition: (row) => {
        switch (row.ServiceRequestTypeId) {
          case 2: //INSTALACION
          case 3: //DESINSTALACION
          case 4: //CAMBIO DE EQUIPO
            return row.ContractCode ? true : false;
          default:
            return true;
        }
      }
    },
    {
      icon: "el-icon-document-checked",
      label: "Validar Contrato",
      command: "validate-contract",
      condition: (row) => {
        switch (row.ServiceRequestTypeId) {
          case 2: //INSTALACION
          case 3: //DESINSTALACION
          case 4: //CAMBIO DE EQUIPO
            return row.ContractCode ? false : true;
          default:
            return false;
        }
      }
    },
    {
      icon: "el-icon-plus",
      label: "Activar GPS en Demo",
      command: "DeviceActivationNavixy"
    },
    {
      icon: "el-icon-plus",
      label: "Activar GPS en Cliente",
      command: "DeviceActivationNavixyBridge"
    },
    actionCancel,
    {
      icon: "el-icon-circle-close",
      label: "Cerrar",
      command: "close"
    }
    // {
    //   icon: "el-icon-plus",
    //   label: "Coordinar instalacion",
    //   command: "coordinate_instalation"
    // },
    // {
    //   icon: "el-icon-plus",
    //   label: "Coordinar instalacion",
    //   command: "coordinate_instalation",
    //   condition: row => {
    //     return row.RequiresInstallersCoordination === true;
    //   }
    // },
    // {
    //   icon: "el-icon-plus",
    //   label: "Registrar dispositivos",
    //   command: "register_diveces",
    //   condition: row => {
    //     return (
    //       !row.RequiresInstallersCoordination && row.RequiresDeviceRegistration
    //     );
    //   }
    // }
  ],
  4: [
    actionView,
    actionCancel,
    {
      icon: "el-icon-unlock",
      label: "Reabrir",
      command: "reopen"
    },
    // {
    //   icon: "el-icon-plus",
    //   command: "record_rating",
    //   label: "Calificar"
    // },
    {
      icon: "el-icon-plus",
      command: "validate",
      label: "Validar con cliente"
    }
  ],
  12: [
    actionView,
    actionCancel,
    {
      icon: "el-icon-plus",
      command: "markInventoryAsUpdated",
      label: "Inventario actualizado"
    }
  ],
  5: [actionView, actionCancel],
  17: [
    actionView,
    actionCancel,
    { icon: "el-icon-plus", command: "record_rating", label: "Calificar" },
    {
      label: "Nueva iteracion",
      icon: "el-icon-plus",
      command: "new_interaction"
    }
  ],
  9: [actionView, actionCancel],
  14: [actionView, actionCancel],
  10: [
    actionView,
    {
      icon: "el-icon-plus",
      command: "markContractAsUpdated",
      label: "Contrato Revisado"
    }
  ]
};

export const RULES = {
  "assign-technician": {
    comment: [
      {
        min: 3,
        message: "Length should be 3",
        trigger: "blur"
      }
    ],
    technical: [
      {
        required: true,
        message: "Debe indicar el tecnico",
        trigger: "blur"
      }
    ]
  },
  reallocate: {
    comment: [
      {
        required: true,
        message: "Debe introducir un comentario",
        trigger: "blur"
      },
      {
        min: 3,
        message: "Length should be 3",
        trigger: "blur"
      }
    ],
    technical: [
      {
        required: true,
        message: "Debe indicar el tecnico",
        trigger: "blur"
      }
    ]
  },
  cancel: {
    comment: [
      {
        required: true,
        message: "Debe introducir un comentario",
        trigger: "blur"
      },
      {
        min: 3,
        message: "Length should be 3",
        trigger: "blur"
      }
    ]
  },
  close: {
    comment: [
      {
        required: true,
        message: "Debe introducir un comentario",
        trigger: "blur"
      },
      {
        min: 3,
        message: "Length should be 3",
        trigger: "blur"
      }
    ]
  },
  reopen: {
    comment: [
      {
        required: true,
        message: "Debe introducir un comentario",
        trigger: "blur"
      },
      {
        min: 3,
        message: "Length should be 3",
        trigger: "blur"
      }
    ]
  },
  markContractAsUpdated: {
    comment: [
      {
        required: true,
        message: "Debe introducir un comentario",
        trigger: "blur"
      },
      {
        min: 3,
        message: "Length should be 3",
        trigger: "blur"
      }
    ]
  },
  markInventoryAsUpdated: {
    comment: [
      {
        required: true,
        message: "Debe introducir un comentario",
        trigger: "blur"
      },
      {
        min: 3,
        message: "Length should be 3",
        trigger: "blur"
      }
    ]
  },
  none: {}
};

export const technicians = [
  {
    value: 127,
    label: "Abel Paredes Nin"
  },
  {
    value: 42,
    label: "Nancy Esther Quezada"
  },
  {
    value: 67,
    label: "Almanzor  Mesa Almanzar"
  },
  {
    value: 102,
    label: "Anderson Gomez Reyes"
  },
  {
    value: 63,
    label: "Anglorys Penelope Mejia Suarez"
  },
  {
    value: 78,
    label: "Broidis Matos Grullon"
  },
  {
    value: 120,
    label: "carlos  montero"
  },
  {
    value: 65,
    label: "Carlos José Tapia Meran"
  },
  {
    value: 43,
    label: "Fausto José Genao Regalado"
  },
  {
    value: 132,
    label: "Gilberto Antonio Peña Mejía"
  },
  {
    value: 68,
    label: "Gregory Vicente Ramirez"
  },
  {
    value: 121,
    label: "Jean Carlos  Guerrero"
  },
  {
    value: 122,
    label: "Juan Almonte"
  },
  {
    value: 92,
    label: "uan Miguel Herrera"
  },
  {
    value: 96,
    label: "Luis Rafael Victoria"
  },
  {
    value: 37,
    label: "Maximiliano Seipio Martins"
  },
  {
    value: 80,
    label: "Nelfri Sigfrido Del Bois"
  },
  {
    value: 99,
    label: "Anderson Vargas"
  }
];

export const COMMON_DIALOG = {
  visible: false,
  confirmLoading: false,
  requestId: 0,
  comment: "",
  title: "",
  type: "",
  technical: "",
  confirm: {
    loading: false
  },
  request: {}
};
